<form #treeForm="ngForm" (ngSubmit)="onSubmit()">
  <ng-container *ngIf="!item || !editedItem.text">
    <mat-form-field class="label">
      <mat-label>{{ 'mapping.base.edit.label.shortLabel' | translate }}</mat-label>
      <input matInput appAutofocus name="label" required maxlength="100" [(ngModel)]="editedItem.label">
    </mat-form-field>

    <mat-form-field class="description">
      <mat-label>{{ 'mapping.base.edit.description.shortLabel' | translate }}</mat-label>
      <textarea matInput name="description" rows="3" maxlength="500" [(ngModel)]="editedItem.description"></textarea>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="editedItem.text">
    <mat-form-field class="label">
      <mat-label>{{ 'mapping.base.edit.label.shortLabel' | translate }}</mat-label>
      <input matInput appAutofocus name="label" required maxlength="100" [(ngModel)]="editedItem.text.fullLabel">
    </mat-form-field>

    <mat-form-field class="description">
      <mat-label>{{ 'mapping.base.edit.description.shortLabel' | translate }}</mat-label>
      <textarea matInput name="description" rows="3" maxlength="500" [(ngModel)]="editedItem.text.detail"></textarea>
    </mat-form-field>
  </ng-container>

  <section class="actions" *ngIf="editedItem.properties && editedItem.properties.length">
    <button mat-button color="accent" type="button" (click)="onToggleAdvanced()">
      <span *ngIf="!showAdvanced">{{ 'mapping.base.edit.showAdvanced.fullLabel' | translate }}</span>
      <span *ngIf="showAdvanced">{{ 'mapping.base.edit.hideAdvanced.fullLabel' | translate }}</span>
      <mat-icon>{{ showAdvanced ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </section>

  <ng-container *ngIf="showAdvanced">
    <mat-form-field class="input-property" *ngFor="let property of editedItem.properties; index as i">
      <mat-label>{{ property.name }}</mat-label>
      <input matInput name="input{{i}}" *ngIf="!property.list" [type]="property.type" [(ngModel)]="property.value">

      <mat-select name="list{{i}}" *ngIf="property.list" [(ngModel)]="property.value">
        <mat-option [value]="null"> - </mat-option>
        <mat-option *ngFor="let item of castArray(property.list)" [value]="item">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>

  <section class="actions">
    <button mat-icon-button color="accent" type="submit" [disabled]="treeForm.invalid"
      [matTooltip]="'mapping.base.edit.submit.fullLabel' | translate">
      <mat-icon>check</mat-icon>
    </button>
    <button mat-icon-button color="accent" type="button" [matTooltip]="'mapping.base.edit.cancel.fullLabel' | translate"
      (click)="onCancel()">
      <mat-icon>clear</mat-icon>
    </button>
  </section>
</form>